var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 33,
    viewBox: "0 0 38 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 .749H3A2.668 2.668 0 0 0 .334 3.416v21.332A2.668 2.668 0 0 0 3 27.415h11.36a4.57 4.57 0 0 1-2.009 1.777c-.818.498-1.6.96-1.778 1.778a1.78 1.78 0 0 0 .604 1.476.89.89 0 0 0 .712.302H26.11a.888.888 0 0 0 .622-.267c.44-.373.672-.936.622-1.51-.106-.854-.889-1.316-1.777-1.778a4.57 4.57 0 0 1-2.01-1.778H35a2.667 2.667 0 0 0 2.666-2.667V3.416A2.668 2.668 0 0 0 35 .749zm.888 21.333H2.111V3.416A.89.89 0 0 1 3 2.526h31.999a.89.89 0 0 1 .889.89v18.666z",
    fill: "#E20074"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.01e09fbeccad8a6becb8162a2499fe2d.svg";
export { ForwardRef as ReactComponent };